"use client";

import { Flex } from "@ecco/ui/flex";
import { ProductImageFrame } from "@ecco/ui/product-image-frame";
import { Swiper, SwiperSlide, type SwiperClass } from "@ecco/ui/swiper-exports";
import { useBreakpoint } from "@ecco/ui/use-breakpoint";
import type { FC } from "react";
import { useState } from "react";

type Props = {
    images: string[];
    isExpanded: boolean;
    alt: string;
    onSwiperInit?: (swiper: SwiperClass) => void;
};

export const ProductTileImageCarousel: FC<Props> = ({ images, isExpanded, alt, onSwiperInit }) => {
    const isLg = useBreakpoint("lg");

    const [imageIndex, setImageIndex] = useState(0);

    const showDots = !isLg || isExpanded;

    return (
        <>
            <Swiper
                slidesPerView={1}
                spaceBetween={1}
                loop
                threshold={20}
                initialSlide={imageIndex}
                onSwiper={onSwiperInit}
                onSlideChange={(swiper) => setImageIndex(swiper.realIndex)}
            >
                {images.map((src, i) => (
                    <SwiperSlide key={i}>
                        <ProductImageFrame
                            sizes={["50vw", "50vw", "33vw", "25vw"]}
                            src={src}
                            alt={alt}
                        />
                    </SwiperSlide>
                ))}
            </Swiper>
            {showDots && (
                <Flex
                    position="absolute"
                    bottom={isLg ? 5 : 2}
                    left={isLg ? 6 : 2}
                    right={isLg ? 6 : 2}
                    zIndex={1}
                    alignItems="flex-end"
                    justifyContent={isLg ? "space-between" : "center"}
                    pointerEvents="none"
                >
                    <Flex gap={1} alignItems="center">
                        {images.map((_, i) =>
                            i === imageIndex ? (
                                <svg
                                    key={i}
                                    width="6"
                                    height="6"
                                    viewBox="0 0 6 6"
                                    fill="none"
                                    aria-hidden="true"
                                    focusable="false"
                                >
                                    <circle
                                        cx="3"
                                        cy="3"
                                        r="2.5"
                                        fill="rgba(255,255,255,0.75)"
                                        stroke="#C6C6C6"
                                    />
                                </svg>
                            ) : (
                                <svg
                                    key={i}
                                    width="4"
                                    height="4"
                                    viewBox="0 0 4 4"
                                    fill="none"
                                    aria-hidden="true"
                                    focusable="false"
                                >
                                    <circle cx="2" cy="2" r="2" fill="#C6C6C6" />
                                </svg>
                            )
                        )}
                    </Flex>
                </Flex>
            )}
        </>
    );
};
